<template>
  <div>
    <headers :show="show" :activeIndex="4"></headers>
    <div class="zong">
      <div class="head">
        <div class="title">加入绿萝分发VIP，畅享高效办公</div>
        <div class="xuanChuan">
          <div class="imgg">
            <img src="../assets/dui.png" alt="" />
            <div class="wenzi">一站式高效办公</div>
          </div>
          <div class="imgg">
            <img src="../assets/dui.png" alt="" />
            <div class="wenzi">正规企业发票</div>
          </div>
          <div class="imgg">
            <img src="../assets/dui.png" alt="" />
            <div class="wenzi">专属售后客服</div>
          </div>
          <div class="imgg">
            <img src="../assets/dui.png" alt="" />
            <div class="wenzi">新功能免费支持</div>
          </div>
        </div>
        <div class="bttn">
          <div
            class="button"
            style="cursor: pointer"
            :class="{ active: currentVersion === 'personal' }"
            @click="selectVersion('personal')"
          >
            个人版
          </div>
          <div
            class="button"
            style="cursor: pointer"
            :class="{ active: currentVersion === 'enterprise' }"
            @click="selectVersion('enterprise')"
          >
            企业版
          </div>
        </div>
      </div>
      <div class="zong-card" v-if="currentVersion === 'personal'">
        <div class="card">
          <div class="card-title">
            <div class="yonghu">免费用户</div>
            <div class="shihe">适合个人使用</div>
            <div class="mianfei">永久免费</div>
          </div>
          <div class="card-item">
            <div class="card-item-title">
              <img src="../assets/fire.png" alt="" />
              <div class="card-zi">热门功能</div>
            </div>
            <div class="card-item-2">
              <div class="add">添加账号：5个</div>
            </div>
            <div class="card-item-3">
              <div class="card-item-zi">
                同时登录：<span class="num">1台设备</span>
              </div>
              <div class="card-item-zi">
                视频列队：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                批量发内容：<span class="num active">不支持</span>
              </div>
              <div class="card-item-zi">
                内容多平台一键发布：<span class="num">4篇/天</span>
              </div>
              <div class="card-item-zi" style="padding-bottom: 18px">
                AI混剪赠送时长：<span class="num">不赠送</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #edf7fe 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/chuangzuo.png" alt="" />
              <div class="card-zi">创作功能</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                AI视频混剪：<span class="num active">不支持</span>
              </div>
              <div class="card-item-zi">
                视频工具箱：<span class="num active">不支持</span>
              </div>
              <div class="card-item-zi">
                视频提取文案时长：<span class="num active">不支持</span>
              </div>
              <div class="card-item-zi">
                批量提取视频文案：<span class="num active">不支持</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #ededed 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/dy.png" alt="" />
              <div class="card-zi">抖音评论管理</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                授权账号数量：<span class="num active">不支持</span>
              </div>
              <div class="card-item-zi">
                评论自动回复：<span class="num active">不支持</span>
              </div>
              <div class="card-item-zi">
                多账号评论聚合：<span class="num active">不支持</span>
              </div>
              <div class="card-item-zi" style="padding-bottom: 14px">
                赠送回复条数：<span class="num active">不支持</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #f2f1fd 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/xin.png" alt="" />
              <div class="card-zi">抖音私信管理</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                授权账号数量：<span class="num active">不支持</span>
              </div>
              <div class="card-item-zi">
                私信聚合管理：<span class="num active">不支持</span>
              </div>
              <div class="card-item-zi">
                私信自动回复：<span class="num active">不支持</span>
              </div>
              <div class="card-item-zi">
                私信回复规则数量：<span class="num active">不支持</span>
              </div>
              <div class="card-item-zi">
                私信提醒：<span class="num active">不支持</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #fff1ee 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/duopingtai.png" alt="" />
              <div class="card-zi">多平台互动管理</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                多平台评论聚合管理：<span class="num active">不支持</span>
              </div>
              <div class="card-item-zi">
                多平台私信聚合管理：<span class="num active">不支持</span>
              </div>
            </div>
          </div>
          <div class="bttn1" style="margin-top: 20px">
            <button>永久免费</button>
          </div>
        </div>
        <div class="card">
          <div class="card-title" style="background: #4fb2f9">
            <div class="yonghu">初级VIP</div>
            <div class="shihe">适合个人使用</div>
            <div class="mianfei">月卡￥39 · 年卡￥259 · 3年￥739</div>
          </div>
          <div class="card-item">
            <div class="card-item-title">
              <img src="../assets/fire.png" alt="" />
              <div class="card-zi">热门功能</div>
            </div>
            <div class="card-item-2">
              <div class="add">添加账号：20个</div>
            </div>
            <div class="card-item-3">
              <div class="card-item-zi">
                同时登录：<span class="num">2台设备</span>
              </div>
              <div class="card-item-zi">
                视频列队：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                批量发内容：<span class="num">月5个/次，年20个/次</span>
              </div>
              <div class="card-item-zi">
                内容多平台一键发布：<span class="num active1">不限制</span>
              </div>
              <div class="card-item-zi" style="padding-bottom: 18px">
                AI混剪赠送时长：<span class="num">不赠送</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #edf7fe 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/chuangzuo.png" alt="" />
              <div class="card-zi">创作功能</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                AI视频混剪：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                视频工具箱：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                视频提取文案时长：<span class="num">仅年付10个</span>
              </div>
              <div class="card-item-zi">
                批量提取视频文案：<span class="num">仅年付10小时</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #ededed 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/dy.png" alt="" />
              <div class="card-zi">抖音评论管理</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                授权账号数量：<span class="num active">不支持</span>
              </div>
              <div class="card-item-zi">
                评论自动回复：<span class="num active">不支持</span>
              </div>
              <div class="card-item-zi">
                多账号评论聚合：<span class="num active">不支持</span>
              </div>
              <div class="card-item-zi" style="padding-bottom: 14px">
                赠送回复条数：<span class="num active">不支持</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #f2f1fd 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/xin.png" alt="" />
              <div class="card-zi">抖音私信管理</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                授权账号数量：<span class="num active">不支持</span>
              </div>
              <div class="card-item-zi">
                私信聚合管理：<span class="num active">不支持</span>
              </div>
              <div class="card-item-zi">
                私信自动回复：<span class="num active">不支持</span>
              </div>
              <div class="card-item-zi">
                私信回复规则数量：<span class="num active">不支持</span>
              </div>
              <div class="card-item-zi">
                私信提醒：<span class="num active">不支持</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #fff1ee 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/duopingtai.png" alt="" />
              <div class="card-zi">多平台互动管理</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                多平台评论聚合管理：<span class="num active">不支持</span>
              </div>
              <div class="card-item-zi">
                多平台私信聚合管理：<span class="num active">不支持</span>
              </div>
            </div>
            <div class="bttn1">
              <button style="background-color: #4fb2f9; margin-top: 20px">
                请在客户端购买
              </button>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-title" style="background: #ff6842">
            <div class="yonghu">中级VIP</div>
            <div class="shihe">适合个人或小微企</div>
            <div class="mianfei">月卡￥49 · 年卡￥389 · 3年￥1089</div>
          </div>
          <div class="card-item">
            <div class="card-item-title">
              <img src="../assets/fire.png" alt="" />
              <div class="card-zi">热门功能</div>
            </div>
            <div class="card-item-2">
              <div class="add">添加账号：50个</div>
            </div>
            <div class="card-item-3">
              <div class="card-item-zi">
                同时登录：<span class="num">2台设备</span>
              </div>
              <div class="card-item-zi">
                视频列队：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                批量发内容：<span class="num">月5个/次，年20个/次</span>
              </div>
              <div class="card-item-zi">
                内容多平台一键发布：<span class="num active1">不限制</span>
              </div>
              <div class="card-item-zi">
                <div>AI混剪赠送时长：</div>
                <div class="num">年1200创点/3年4000创点</div>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #edf7fe 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/chuangzuo.png" alt="" />
              <div class="card-zi">创作功能</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                AI视频混剪：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                视频工具箱：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                视频提取文案时长：<span class="num">月2个/年20个</span>
              </div>
              <div class="card-item-zi">
                批量提取视频文案：<span class="num">月1.5小时/年20小时</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #ededed 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/dy.png" alt="" />
              <div class="card-zi">抖音评论管理</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                授权账号数量：<span class="num">50个</span>
              </div>
              <div class="card-item-zi">
                评论自动回复：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                多账号评论聚合：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                <div>赠送回复条数：</div>
                <div class="num">月300条/年3600条/3年11800条</div>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #f2f1fd 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/xin.png" alt="" />
              <div class="card-zi">抖音私信管理</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                授权账号数量：<span class="num">1个</span>
              </div>
              <div class="card-item-zi">
                私信聚合管理：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                私信自动回复：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                私信回复规则数量：<span class="num">2个（仅年付）</span>
              </div>
              <div class="card-item-zi">
                私信提醒：<span class="num">支持（仅年付）</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #fff1ee 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/duopingtai.png" alt="" />
              <div class="card-zi">多平台互动管理</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                多平台评论聚合管理：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                多平台私信聚合管理：<span class="num active1">支持</span>
              </div>
            </div>
            <div class="bttn1">
              <button style="background-color: #ff6842; margin-top: 20px">
                请在客户端购买
              </button>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-title" style="background-color: #333333">
            <div class="yonghu">高级VIP</div>
            <div class="shihe">适合个人或中小型公司</div>
            <div class="mianfei">月卡￥169 · 年卡￥1269 · 3年￥3849</div>
          </div>
          <div class="card-item">
            <div class="card-item-title">
              <img src="../assets/fire.png" alt="" />
              <div class="card-zi">热门功能</div>
            </div>
            <div class="card-item-2">
              <div class="add">添加账号：200个</div>
            </div>
            <div class="card-item-3">
              <div class="card-item-zi">
                同时登录：<span class="num">10台设备</span>
              </div>
              <div class="card-item-zi">
                视频列队：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                批量发内容：<span class="num">月10个/次，年30个/次</span>
              </div>
              <div class="card-item-zi">
                内容多平台一键发布：<span class="num">不限制</span>
              </div>
              <div class="card-item-zi">
                <div>AI混剪赠送时长：</div>
                <div class="num">年5000创点/3年18000创点</div>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #edf7fe 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/xin.png" alt="" />
              <div class="card-zi">创作功能</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                AI视频混剪：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                视频工具箱：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                视频提取文案时长：<span class="num">月10个/年30个</span>
              </div>
              <div class="card-item-zi">
                批量提取视频文案：<span class="num">月10小时/年80小时</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #ededed 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/dy.png" alt="" />
              <div class="card-zi">抖音评论管理</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                授权账号数量：<span class="num">200个</span>
              </div>
              <div class="card-item-zi">
                评论自动回复：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                多账号评论聚合：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                <div>赠送回复条数：</div>
                <div class="num">月1200条/年14400条/3年43800条</div>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #f2f1fd 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/xin.png" alt="" />
              <div class="card-zi">抖音私信管理</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                授权账号数量：<span class="num">10个</span>
              </div>
              <div class="card-item-zi">
                私信聚合管理：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                私信自动回复：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                私信回复规则数量：<span class="num">2个</span>
              </div>
              <div class="card-item-zi">
                私信提醒：<span class="num active1">支持</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #fff1ee 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/duopingtai.png" alt="" />
              <div class="card-zi">多平台互动管理</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                多平台评论聚合管理：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                多平台私信聚合管理：<span class="num active1">支持</span>
              </div>
            </div>
            <div class="bttn1">
              <button style="background-color: #333333; margin-top: 20px">
                请在客户端购买
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="zong-card" v-if="currentVersion === 'enterprise'">
        <div class="card" style="width: 340px">
          <div class="card-title" style="background: #4fb2f9">
            <div class="yonghu">团队初级VIP</div>
            <div class="shihe">适合公司/小型工作室</div>
            <div class="mianfei">月卡￥79 · 年卡￥579 · 3年￥1659</div>
          </div>
          <div class="card-item">
            <div class="card-item-title">
              <img src="../assets/fire.png" alt="" />
              <div class="card-zi" style="margin-bottom: 14px">热门功能</div>
            </div>
            <div class="card-item-2">
              <div class="add">添加自媒体账号：50个</div>
            </div>
            <div class="card-item-3">
              <div class="card-item-zi">
                同时登录：<span class="num active1">不限制</span>
              </div>
              <div class="card-item-zi">
                视频列队：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                批量发内容：<span class="num">月5个/次，年20个/次</span>
              </div>
              <div class="card-item-zi">
                内容多平台一键发布：<span class="num active1">不限制</span>
              </div>
              <div class="card-item-zi" style="padding-bottom: 18px">
                AI混剪赠送时长：<span class="num">年2000创点/3年6200创点</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  45deg,
                  #eff8ef 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/teamEdition.png" alt="" />
              <div class="card-zi">团队功能</div>
            </div>
            <div class="card-item-2">
              <div class="add" style="color: #59bb54">
                子账号创建数（员工号）：5个
              </div>
            </div>
            <div class="card-item-3">
              <div class="card-item-zi">
                屏蔽子账号收益查看：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                屏蔽自媒体账号密码：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                屏蔽运营数据：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                子账号数据监控：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                子账号媒体号管理：<span class="num active1">支持</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #edf7fe 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/chuangzuo.png" alt="" />
              <div class="card-zi">创作功能</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                AI视频混剪：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                视频工具箱：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                视频提取文案时长：<span class="num">月2个/年35小时</span>
              </div>
              <div class="card-item-zi">
                批量提取视频文案：<span class="num">月2个/年35小时</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #ededed 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/dy.png" alt="" />
              <div class="card-zi">抖音评论管理</div>
            </div>
            <div class="card-item-2">
              <div class="add" style="color: black">授权账号数量：50个</div>
            </div>
            <div class="card-item-3" style="padding-bottom: 18px">
              <div class="card-item-zi">
                评论自动回复：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                多账号评论聚合：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi" style="padding-bottom: 14px">
                赠送回复条数：<span class="num"
                  >月600条/年7200条/3年21800条</span
                >
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #f2f1fd 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/xin.png" alt="" />
              <div class="card-zi">抖音私信管理</div>
            </div>
            <div class="card-item-2">
              <div class="add">授权账号数量：5个</div>
            </div>
            <div class="card-item-3">
              <div class="card-item-zi">
                私信聚合管理：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                私信自动回复：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                私信回复规则数量：<span class="num">1个</span>
              </div>
              <div class="card-item-zi">
                私信提醒：<span class="num active1">支持</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #fff1ee 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/duopingtai.png" alt="" />
              <div class="card-zi">多平台互动管理</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                多平台评论聚合管理：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                多平台私信聚合管理：<span class="num active1">支持</span>
              </div>
            </div>
            <div class="bttn1">
              <button
                style="
                  background-color: #4fb2f9;
                  margin-top: 20px;
                  margin-bottom: 18px;
                "
              >
                请在客户端购买
              </button>
            </div>
          </div>
        </div>
        <div class="card" style="width: 340px">
          <div class="card-title" style="background: #ff6842">
            <div class="yonghu">团队中级VIP</div>
            <div class="shihe">适合中小型公司或中型工作室</div>
            <div class="mianfei">月卡￥269 · 年卡￥1979 · 3年￥5999</div>
          </div>
          <div class="card-item">
            <div class="card-item-title">
              <img src="../assets/fire.png" alt="" />
              <div class="card-zi" style="margin-bottom: 14px">热门功能</div>
            </div>
            <div class="card-item-2">
              <div class="add">添加自媒体账号：200个</div>
            </div>
            <div class="card-item-3">
              <div class="card-item-zi">
                同时登录：<span class="num active1">不限制</span>
              </div>
              <div class="card-item-zi">
                视频列队：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                批量发内容：<span class="num">月5个/次，年20个/次</span>
              </div>
              <div class="card-item-zi">
                内容多平台一键发布：<span class="num active1">不限制</span>
              </div>
              <div class="card-item-zi" style="padding-bottom: 18px">
                AI混剪赠送时长：<span class="num"
                  >年10000创点/3年35000创点</span
                >
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  45deg,
                  #eff8ef 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/teamEdition.png" alt="" />
              <div class="card-zi">团队功能</div>
            </div>
            <div class="card-item-2">
              <div class="add" style="color: #59bb54">
                子账号创建数（员工号）：20个
              </div>
            </div>
            <div class="card-item-3">
              <div class="card-item-zi">
                屏蔽子账号收益查看：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                屏蔽自媒体账号密码：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                屏蔽运营数据：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                子账号数据监控：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                子账号媒体号管理：<span class="num active1">支持</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #edf7fe 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/chuangzuo.png" alt="" />
              <div class="card-zi">创作功能</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                AI视频混剪：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                视频工具箱：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                视频提取文案时长：<span class="num">月20个/年30个</span>
              </div>
              <div class="card-item-zi">
                批量提取视频文案：<span class="num">月15小时/年140小时</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #ededed 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/dy.png" alt="" />
              <div class="card-zi">抖音评论管理</div>
            </div>
            <div class="card-item-2">
              <div class="add" style="color: black">授权账号数量：200个</div>
            </div>
            <div class="card-item-3" style="padding-bottom: 18px">
              <div class="card-item-zi">
                评论自动回复：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                多账号评论聚合：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi" style="padding-bottom: 14px">
                赠送回复条数：<span class="num"
                  >月2400条/年28800条/3年86800条</span
                >
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #f2f1fd 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/xin.png" alt="" />
              <div class="card-zi">抖音私信管理</div>
            </div>
            <div class="card-item-2">
              <div class="add" style="color: #6358ed">授权账号数量：20个</div>
            </div>
            <div class="card-item-3">
              <div class="card-item-zi">
                私信聚合管理：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                私信自动回复：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                私信回复规则数量：<span class="num">5个</span>
              </div>
              <div class="card-item-zi">
                私信提醒：<span class="num active1">支持</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #fff1ee 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/duopingtai.png" alt="" />
              <div class="card-zi">多平台互动管理</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                多平台评论聚合管理：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                多平台私信聚合管理：<span class="num active1">支持</span>
              </div>
            </div>
            <div class="bttn1">
              <button
                style="
                  background: #ff6842;
                  margin-top: 20px;
                  margin-bottom: 18px;
                "
              >
                请在客户端购买
              </button>
            </div>
          </div>
        </div>
        <div class="card" style="width: 340px">
          <div class="card-title" style="background: #333333">
            <div class="yonghu">团队高级VIP</div>
            <div class="shihe">适合中性公司或大型工作室</div>
            <div class="mianfei">月卡￥649 · 年卡￥4659 · 3年￥12949</div>
          </div>
          <div class="card-item">
            <div class="card-item-title">
              <img src="../assets/fire.png" alt="" />
              <div class="card-zi">热门功能</div>
            </div>
            <div class="card-item-2">
              <div class="add">添加自媒体账号：1000个</div>
            </div>
            <div class="card-item-3">
              <div class="card-item-zi">
                同时登录：<span class="num active1">不限制</span>
              </div>
              <div class="card-item-zi">
                视频列队：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                批量发内容：<span class="num">月5个/次，年20个/次</span>
              </div>
              <div class="card-item-zi">
                内容多平台一键发布：<span class="num active1">不限制</span>
              </div>
              <div class="card-item-zi">
                <div style="padding-bottom: 18px">AI混剪赠送时长：</div>
                <div class="num">年10000创点/3年35000创点</div>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  45deg,
                  #eff8ef 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/teamEdition.png" alt="" />
              <div class="card-zi">团队功能</div>
            </div>
            <div class="card-item-2">
              <div class="add" style="color: #59bb54">
                子账号创建数（员工号）：100个
              </div>
            </div>
            <div class="card-item-3">
              <div class="card-item-zi">
                屏蔽子账号收益查看：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                屏蔽自媒体账号密码：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                屏蔽运营数据：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                子账号数据监控：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                子账号媒体号管理：<span class="num active1">支持</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #edf7fe 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/chuangzuo.png" alt="" />
              <div class="card-zi">创作功能</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                AI视频混剪：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                视频工具箱：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                视频提取文案时长：<span class="num">月30个/年30个</span>
              </div>
              <div class="card-item-zi">
                批量提取视频文案：<span class="num">月40小时/年300小时</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #ededed 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/dy.png" alt="" />
              <div class="card-zi">抖音评论管理</div>
            </div>
            <div class="card-item-2">
              <div class="add" style="color: black">授权账号数量：200个</div>
            </div>
            <div class="card-item-3">
              <div class="card-item-zi">
                评论自动回复：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                多账号评论聚合：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi" style="padding-bottom: 14px">
                赠送回复条数：<span class="num"
                  >月4800条/年57600条/3年172800条</span
                >
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #f2f1fd 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/xin.png" alt="" />
              <div class="card-zi">抖音私信管理</div>
            </div>
            <div class="card-item-2">
              <div class="add" style="color: #6358ed">授权账号数量：50个</div>
            </div>
            <div class="card-item-3">
              <div class="card-item-zi">
                私信聚合管理：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                私信自动回复：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                私信回复规则数量：<span class="num">20个</span>
              </div>
              <div class="card-item-zi">
                私信提醒：<span class="num active1">支持</span>
              </div>
            </div>
          </div>
          <div class="card-item">
            <div
              class="card-item-title"
              style="
                background: linear-gradient(
                  90deg,
                  #fff1ee 0%,
                  rgba(255, 255, 255, 0) 100%
                );
              "
            >
              <img src="../assets/duopingtai.png" alt="" />
              <div class="card-zi">多平台互动管理</div>
            </div>

            <div class="card-item-3">
              <div class="card-item-zi">
                多平台评论聚合管理：<span class="num active1">支持</span>
              </div>
              <div class="card-item-zi">
                多平台私信聚合管理：<span class="num active1">支持</span>
              </div>
            </div>
            <div class="bttn1">
              <button style="background: #333333; margin-top: 20px">
                请在客户端购买
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tips">升级或以上套餐不满足您？请联系右侧企微在线客服处理</div>
    <div class="demo-collapse">
      <el-collapse v-model="activeNames" @change="handleChange" accordion>
        <el-collapse-item title="Q：添加账号数" name="1" :icon="CaretRight">
          <div>
            单个绿萝分发账号，所有登录设备上，所添加的所有自媒体平台账号之和（不同设备添加同一账号，只算一个；同一名字/账密，不同平台，算为独立的账号）要注意：绿萝分发并不提供媒体账号，主要功能的实现，需要用户自备自媒体平台账号
            举例：张三是中级VIP，拥有添加50个账号的权限；那么他可以只添加某音50个；或者添加某音20、头条30个；不限制添加的平台，只限制添加账号的总数。
          </div>
        </el-collapse-item>
        <el-collapse-item title="Q：设备同时登录" name="3">
          设备同时登录数：指的是同时唯一登陆（类似pc版微信），你可以在多台电脑登录绿萝分发，但如果只有1台的权限，那么只允许同时在一台设备登录。
        </el-collapse-item>
        <el-collapse-item title="Q：如何开票" name="4">
          默认发票类型：增值税普票(电子票) | 信息技术服务-软件服务如何提交:
          将开票信息，订单号提交给官网客服（客服入口：网站右侧悬浮窗、客户端右上角）建议订单金额满200后申请。
        </el-collapse-item>
      </el-collapse>
    </div>
    <footers></footers>
  </div>
</template>
<script>
import footers from "../router/components/footer/footer.vue";
import headers from "../router/components/header/header.vue";

export default {
  name: "VIP",
  components: {
    footers,
    headers,
  },
  mixins: [],
  props: {},
  data() {
    return {
      show: false,
      currentVersion: "personal", // 默认选中个人版
      activeNames: ["1"],
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    selectVersion(version) {
      this.currentVersion = version;
    },
  },
};
</script>
<style lang="less" scoped>
.page {
  background-color: #ffffff;
}

.zong {
  .head {
    background-color: #6c65f2;
    height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;

    .title {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: bold;
      font-size: 36px;
      color: #ffffff;
      line-height: 42px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    .xuanChuan {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 60px;

      .imgg {
        display: flex;
        align-items: center;
        gap: 10px;

        img {
          width: 24px;
          height: 24px;
        }

        .wenzi {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 16px;
          color: #ffffff;
          line-height: 19px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
    }

    .bttn {
      display: flex;
      align-items: center;
      gap: 40px;
      justify-content: center;
      margin-top: 40px;

      .button {
        width: 100px;
        padding: 10px 25px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #ffffff;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        line-height: 16px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }

      .button.active {
        background-color: white;
        color: blue;
      }
    }
  }

  .zong-card {
    display: flex;
    justify-content: center;
    // align-items: center;
    align-items: flex-start;
    gap: 20px;
    position: relative;
    top: -50px;

    .card {
      width: 280px;
      // background: white;
      // border: 1px solid red;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);

      .card-title {
        height: 136px;
        background: #59bb54;
        border-radius: 12px 12px 12px 12px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 20px;

        .yonghu {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: bold;
          font-size: 24px;
          color: #ffffff;
          line-height: 28px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }

        .shihe {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          line-height: 16px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }

        .mianfei {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 16px;
          color: #ffffff;
          line-height: 19px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
      }

      .card-item {
        margin-top: 20px;

        .card-item-title {
          background: linear-gradient(
            90deg,
            #fdebf0 0%,
            rgba(255, 255, 255, 0) 100%
          );
          border-radius: 0px 0px 0px 0px;
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 0;
          padding-left: 20px;

          img {
            width: 20px;
            height: 20px;
          }

          .card-zi {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 500;
            font-size: 20px;
            color: #333333;
            line-height: 23px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }

        .card-item-2 {
          padding: 20px 0;

          .add {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 500;
            font-size: 16px;
            color: #f02d63;
            line-height: 19px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }

        .card-item-3 {
          padding: 0 10px;
          display: flex;
          flex-direction: column;
          gap: 15px;

          //第一个card-item-zi
          .card-item-zi:first-child {
            margin-top: 15px;
          }

          .card-item-zi {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }

          .num {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }

          .active {
            color: #f02d63;
          }

          .active1 {
            color: #59bb54;
          }
        }
      }

      .bttn1 {
        width: 100%;

        text-align: center;
        padding-bottom: 20px;

        button {
          width: 70%;
          height: 56px;
          background: #59bb54;
          border-radius: 28px 28px 28px 28px;
          border: none;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 18px;
          color: #ffffff;
          line-height: 21px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
      }
    }
  }
}

:deep(.el-collapse-item) {
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  margin-bottom: 20px;
  padding: 0 10px;
  border: none;
}

:deep(.el-collapse-item__header) {
  font-weight: 500;
  font-size: 16px;
  color: #333333;
}

:deep(.el-collapse-item__header.is-active) {
  color: #6358ed;
  font-weight: 500;
  font-size: 16px;
}

.tips {
  text-align: center;
  // margin-top: 40px;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
}

.demo-collapse {
  width: 1200px;
  margin: 40px auto;
}
</style>
